import React from 'react';
import { observer } from 'mobx-react-lite';
import { gameConfigStore, getAmountWithCurrency } from '@pascal/pascal-core';
import { oddStore } from '../../../store';
import { globalTranslationKeys } from '../../../enums';

export const MaxWinNotification = observer(({ t }) => {
  const { MaxWinNote } = globalTranslationKeys;
  const { isMaxWin } = oddStore;
  const { limits } = gameConfigStore;

  return (
    !!Object.values(isMaxWin).some((item) => item) && (
      <div className='min-max-popup-holder'>
        <div className='popups-holder'>
          <div className='max-popup-wrapper'>
            <p className='max-popup-text'>{t(MaxWinNote)}</p>
            <p className='max-popup-text-num'>
              {getAmountWithCurrency({
                amount: (+limits.maxWin).toFixed(2),
              })}
            </p>
            <span className='ui-lib-warning max-popup-icon' />
          </div>
        </div>
      </div>
    )
  );
});
